import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useSelector } from "react-redux";
import style from "./style.module.scss";
import { selectUserRole } from "redux/permission/selector";
import { USER_ROLES } from "helpers/constants";

const DISPLAY_DURATION_MS = 16 * 1000;
const INTERVAL_MS = 4 * DISPLAY_DURATION_MS;

/**
 * SnapshotNotification
 * Hiển thị thông báo nhắc nhở submit mask mỗi INTERVAL_MS.
 * Animation: Icon chuông hiện ra → thanh ngang xổ ra → dòng chữ chạy marquee.
 */
const SnapshotNotification = () => {
  const [visible, setVisible] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);
  const timerRef = useRef(null);
  const fadeTimerRef = useRef(null);
  const userRole = useSelector(selectUserRole);

  const showNotification = useCallback(() => {
    setFadingOut(false);
    setVisible(true);

    // Tự ẩn sau DISPLAY_DURATION_MS
    fadeTimerRef.current = setTimeout(() => {
      setFadingOut(true);
      // Đợi animation fade out xong rồi ẩn hẳn
      setTimeout(() => {
        setVisible(false);
        setFadingOut(false);
      }, 2000);
    }, DISPLAY_DURATION_MS);
  }, []);

  const actionNameByRole = useMemo(() => {
    if (userRole === USER_ROLES.REVIEWER) {
      return "APPROVE";
    }
    if (userRole === USER_ROLES.LABELER) {
      return "SUBMIT";
    }
    return "SUBMIT";
  }, [userRole]);

  const showNoti = useMemo(() => {
    const showedRole = [
      USER_ROLES.LABELER,
      USER_ROLES.REVIEWER,
      USER_ROLES.ADMIN,
      USER_ROLES.PROJECT_MANAGER,
    ];
    return showedRole.includes(userRole) && visible;
  }, [visible, userRole]);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      showNotification();
    }, INTERVAL_MS);

    return () => {
      clearInterval(timerRef.current);
      clearTimeout(fadeTimerRef.current);
    };
  }, [showNotification]);

  if (!showNoti) return null;

  return (
    <div className={`${style.root} ${fadingOut ? style.fadingOut : ""}`}>
      {/* Icon chuông */}
      <div className={style.iconWrapper}>
        <span className={style.bellIcon} role="img" aria-label="notification">
          🔔
        </span>
      </div>

      {/* Thanh ngang với dòng chữ chạy */}
      <div className={style.barWrapper}>
        <span className={style.marqueeText}>
          {actionNameByRole} LẠI để lưu lịch sử mask bản cuối cùng!
        </span>
      </div>
    </div>
  );
};

export default SnapshotNotification;
